import { render, staticRenderFns } from "./SubcontractorList.vue?vue&type=template&id=5976f119&scoped=true"
import script from "./SubcontractorList.vue?vue&type=script&lang=js"
export * from "./SubcontractorList.vue?vue&type=script&lang=js"
import style0 from "./SubcontractorList.vue?vue&type=style&index=0&id=5976f119&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976f119",
  null
  
)

export default component.exports